import {t} from 'app/translations';
import {EskotValidator} from 'utils/eskot-validator';
import {Errors} from 'utils/validator';

import {SubjectFacilityFormValues} from '../../types/subject-facility-form-values';

const te = t('userDetail');

/**
 * Builds the breeder-form validator for create and edit flows.
 *
 * @param farmsRequired Whether farm selection must be present.
 * @param isEdit Whether the form edits an existing breeder relation.
 * @returns A validator that enforces breeder approval and role rules.
 *
 * @example
 * const validate = createValidate(true, false);
 */
export const createValidate = (farmsRequired: boolean, isEdit: boolean) =>
    (values: SubjectFacilityFormValues): Errors<SubjectFacilityFormValues> => {
        const validator = new EskotValidator(values);

        const approveIsInvalid = (
            values.approvedFrom !== null
            && values.approvedTo !== null
            && values.approvedFrom > values.approvedTo
        );

        validator.customRule(
            'approvedTo',
            approveIsInvalid,
            te('dateFromToIsInvalid'),
        );

        if (!isEdit) validator.nonEmpty('approvedFrom', te('approvedFrom'));
        validator.nonEmpty('subjectId', te('breederNumber'));
        if (farmsRequired) validator.nonEmpty('farmIds', te('farms'));
        validator.nonEmpty('roleIds', te('roles'));

        return validator.generateErrorsObject();
    };
